import React, { PureComponent } from 'react'
import { Row, Col, Button } from 'react-bootstrap'
import { Field, reduxForm } from 'redux-form'
import InputDropzone from '../../commons/form/InputDropzone'
import InputSelect from '../../commons/form/InputSelect'
import ImportVehicleModelsResultsModal from './importVehicleModelsResultsModal'
import { handleKeyDown } from '../../../util/utils'
import MapSectionsMasters from '../../../util/map-sections-masters'

class ImportVehicleModelsMaster extends PureComponent {
  constructor () {
    super()
    this.state = { }
  }

  componentDidMount () {
    this.props.actions.fetchBrands()
  }

  submit (values) {
    this.props.actions.importVehicleModelFile({ values: values.vehicleModelFile }, values.brandId)
  }

  render () {
    const {
      t, handleSubmit,
      combos: { brandCombo },
      actions: { openModal }
    } = this.props

    const secMapMasters = MapSectionsMasters.find(function (s) { return s.page === 'importVehicleModelMasterPage' })
    const tKey = 'MASTERS.VEHICLE_MODELS.'

    return (
      <React.Fragment>
        <ImportVehicleModelsResultsModal
          t ={t}
          showModal = {this.props.importVehicleModels.showImportResult}
          importResults = {this.props.importVehicleModels}
          closeModal = {this.props.actions.cancelImportVehicleModelFile}
        />
        <div className="inner-results-panel">
          <div className="section-results-header">
            <div className="section-header-title">
              <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.props.hideMenu ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
                <a onClick={() => this.props.toogleInnerMenu()} className={this.props.hideMenu ? 'collapseBtn' : 'collapseBtn closeInnerMenu'}><i className={this.props.hideMenu ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
              </OverlayTrigger>
              <h4>{t(`${secMapMasters.title}`)}
              </h4>
            </div>
          </div>

          <Row>
            <form autoComplete="off" onSubmit={handleSubmit(this.submit.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
              <Col sm={12} className="input-dropzone-wrapper">
                <Row className="form-group">
                  <Field
                    name="brandId"
                    id="brandId"
                    colSm={3}
                    controlLabel={t(`${tKey}BRAND`)}
                    options={brandCombo}
                    valueKey="id"
                    labelKey="value"
                    component={InputSelect}
                    menuPlacement="auto"
                  />
                </Row>
                <Row className="form-group">
                  {
                    <Col sm={12} className={'document-edition-modal-middle-side'}>
                      <div className={'input-dropzone'} style={{ height: '100%' }}>
                        {
                          <Field
                            key={'field'}
                            colSm={12}
                            id={'vehicleModelFile'}
                            name={'vehicleModelFile' }
                            component={InputDropzone}
                            onInvalidFile={(acceptFiles) => openModal('nonValidFile', null, null, null, null, [{ id: '##FORMAT##', value: acceptFiles }])}
                            t={t}
                            acceptFiles = {'.xlsx, .xls'}
                            maxSizeFile = {20971520}
                            style={{ height: '100%' }}
                            className={'active'}
                          />
                        }
                      </div>
                    </Col>
                  }
                </Row>
                <Row>
                  <Col sm={12}>
                    <div className="text-left">
                      <Button className="btn-standard" type="submit">{t(`${tKey}SAVE`)}</Button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </form>
          </Row>
        </div>
      </React.Fragment>
    )
  }
}

const validate = (values, props) => {
  var error = {}
  if (!values.vehicleModelFile) {
    error.vehicleModelFile = props.t('MASTERS.VEHICLE_MODELS.VALIDATIONS.FILE_NOT_LOADED')
  }
  if (!values.brandId) {
    error.brandId = props.t('MASTERS.VEHICLE_MODELS.VALIDATIONS.BRAND_MANDATORY')
  }
  return error
}

export default reduxForm({
  form: 'ImportVehicleModelsMaster',
  validate
})(ImportVehicleModelsMaster)
